import ReactLoading from "react-loading";

const Loading = ({state=true}) => {
    return(
        <>
        {
            state && 
            <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 loading">
                <ReactLoading type="spin" color="#02B4CC" height={100} width={100} className="loading-spinner" />
                <h3 style={{color: "#02B4CC"}}>{}</h3>
            </div>
        }
        </>
    )
}

export default Loading